import React, { useState } from 'react';
import { NavLink, useLocation  } from 'react-router-dom';
import './Navbar.css';

const navLinks = [
    { url: "/tuotantopalvelut", title: "Tuotantopalvelut" },
    { url: "/tuotannot", title: "Tuotannot" },
    { url: "/hankkeet", title: "Hankkeet" },
    { url: "/referenssit", title: "Referenssit" },
    { url: "/yhteystiedot", title: "Yhteystiedot" },
];

const Navbar = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <nav className="navbar">
            <NavLink to="/" className="nav-logo" onClick={closeMenu}>REMENA</NavLink>
            <div className="menu-icon" onClick={toggleMenu}>
                <div className={isMenuOpen ? 'menu-icon-line open' : 'menu-icon-line'}></div>
                <div className={isMenuOpen ? 'menu-icon-line open' : 'menu-icon-line'}></div>
                <div className={isMenuOpen ? 'menu-icon-line open' : 'menu-icon-line'}></div>
            </div>
            <ul className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
                {navLinks.map((link) => {
                    const isActive = location.pathname === link.url;
                    return (
                        <li
                            key={link.url}
                            className={`nav-item ${isActive ? 'active' : ''}`}
                        >
                            <NavLink
                                to={link.url}
                                className={`nav-link ${isActive ? 'active' : ''}`}
                                data-text={link.title}
                                onClick={closeMenu}
                            >
                                {link.title}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default Navbar;